import { createTheme } from '@mui/material/styles';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import { colors } from './colors';

export const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      dark: colors.primary.dark,
      contrastText: colors.primary.contrastText,
    },
    secondary: {
      main: colors.secondary.main,
      light: colors.secondary.light,
      dark: colors.secondary.dark,
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
    },
    divider: colors.divider,
    action: {
      hover: colors.action.hover,
      selected: colors.action.selected,
      active: colors.action.active,
      disabled: colors.action.disabled,
      disabledBackground: colors.action.disabledBackground,
    },
    success: {
      main: colors.success.main,
      light: colors.success.light,
      dark: colors.success.dark,
    },
    error: {
      main: colors.error.main,
      light: colors.error.light,
      dark: colors.error.dark,
    },
    warning: {
      main: colors.warning.main,
      light: colors.warning.light,
      dark: colors.warning.dark,
    },
    info: {
      main: colors.info.main,
      light: colors.info.light,
      dark: colors.info.dark,
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    fontSize: 14,
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 600,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.8125rem',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.875rem',
    },
    caption: {
      fontSize: '0.75rem',
      color: colors.text.secondary,
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    'none',
    '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.04)',
    '0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.03)',
    '0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.03)',
    '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.03)',
    '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.03)',
    '0 25px 30px -5px rgba(0, 0, 0, 0.1), 0 10px 12px -6px rgba(0, 0, 0, 0.04)',
    '0 30px 40px -10px rgba(0, 0, 0, 0.1), 0 12px 15px -8px rgba(0, 0, 0, 0.04)',
    '0 35px 45px -15px rgba(0, 0, 0, 0.12), 0 15px 20px -10px rgba(0, 0, 0, 0.04)',
    '0 40px 50px -20px rgba(0, 0, 0, 0.12), 0 20px 25px -12px rgba(0, 0, 0, 0.04)',
    '0 45px 55px -25px rgba(0, 0, 0, 0.12), 0 25px 30px -15px rgba(0, 0, 0, 0.04)',
    '0 50px 60px -30px rgba(0, 0, 0, 0.15), 0 30px 35px -18px rgba(0, 0, 0, 0.05)',
    '0 55px 65px -35px rgba(0, 0, 0, 0.15), 0 35px 40px -20px rgba(0, 0, 0, 0.05)',
    '0 60px 70px -40px rgba(0, 0, 0, 0.15), 0 40px 45px -22px rgba(0, 0, 0, 0.05)',
    '0 65px 75px -45px rgba(0, 0, 0, 0.18), 0 45px 50px -25px rgba(0, 0, 0, 0.06)',
    '0 70px 80px -50px rgba(0, 0, 0, 0.18), 0 50px 55px -28px rgba(0, 0, 0, 0.06)',
    '0 75px 85px -55px rgba(0, 0, 0, 0.18), 0 55px 60px -30px rgba(0, 0, 0, 0.06)',
    '0 80px 90px -60px rgba(0, 0, 0, 0.2), 0 60px 65px -32px rgba(0, 0, 0, 0.07)',
    '0 85px 95px -65px rgba(0, 0, 0, 0.2), 0 65px 70px -35px rgba(0, 0, 0, 0.07)',
    '0 90px 100px -70px rgba(0, 0, 0, 0.2), 0 70px 75px -38px rgba(0, 0, 0, 0.07)',
    '0 95px 105px -75px rgba(0, 0, 0, 0.22), 0 75px 80px -40px rgba(0, 0, 0, 0.08)',
    '0 100px 110px -80px rgba(0, 0, 0, 0.22), 0 80px 85px -42px rgba(0, 0, 0, 0.08)',
    '0 105px 115px -85px rgba(0, 0, 0, 0.22), 0 85px 90px -45px rgba(0, 0, 0, 0.08)',
    '0 110px 120px -90px rgba(0, 0, 0, 0.25), 0 90px 95px -48px rgba(0, 0, 0, 0.09)',
  ] as const,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background.default,
          scrollbarWidth: 'thin',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#c1c1c1',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#a8a8a8',
          },
        },
        '.paper-section-title': {
          backgroundColor: colors.common.white,
          borderBottom: `1px solid ${colors.divider}`,
          margin: '0',
          padding: '12px 32px', // Reduced padding
          minHeight: '64px', // Consistent height regardless of content
          borderRadius: '8px 8px 0 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        // Generic string of pearls stepper icon styles
        // '.string-of-pearls-icon': {
        //   backgroundColor: '#ccc',
        //   zIndex: 1,
        //   color: '#fff',
        //   width: 50,
        //   height: 50,
        //   display: 'flex',
        //   borderRadius: '50%',
        //   justifyContent: 'center',
        //   alignItems: 'center',
        //   '&.active': {
        //     backgroundImage:
        //       'linear-gradient(136deg, rgb(69, 139, 247) 0%, rgb(45, 106, 255) 50%, rgb(37, 86, 226) 100%)',
        //     boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.03)', // Using shadow[4] from theme
        //   },
        //   '&.completed': {
        //     backgroundImage:
        //       'linear-gradient(136deg, rgb(69, 139, 247) 0%, rgb(45, 106, 255) 50%, rgb(37, 86, 226) 100%)',
        //   },
        // },
        '.string-of-pearls-icon': {
          zIndex: 1,
          color: '#ccc',
          width: 50,
          height: 50,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          '&.active': {
            color: colors.primary.main,
          },
          '&.completed': {
            color: colors.primary.light,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.background.default,
          color: colors.text.primary,
          boxShadow: 'none',
          borderBottom: 'none',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.background.default,
          border: 'none',
          boxShadow: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: colors.primary.light,
          textDecoration: 'none',
          transition: 'color 0.15s ease-in-out, opacity 0.15s ease-in-out',
          '&:hover': {
            color: colors.primary.dark,
            opacity: 1,
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 1,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid #e2e8f0',
        },
        elevation0: {
          boxShadow: 'none',
          border: '1px solid #e2e8f0',
        },
        elevation1: {
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        },
        rounded: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          border: '1px solid #e2e8f0',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: '8px 16px',
          fontSize: '0.875rem',
          fontWeight: 500,
          //   boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          },
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: colors.primary.dark,
          },
        },
        outlined: {
          borderColor: '#d1d5db',
          '&:hover': {
            backgroundColor: colors.action.hover,
            borderColor: colors.secondary.light,
          },
        },
        text: {
          '&:hover': {
            backgroundColor: colors.action.selected,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.common.white,
          fontSize: '0.875rem',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d1d5db',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.secondary.light,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors.primary.main,
            borderWidth: '1px',
          },
        },
        input: {
          padding: '8.5px 14px',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: colors.common.white,
          borderRadius: '6px 6px 0 0',
          fontSize: '0.875rem',
          '&.Mui-disabled': {
            backgroundColor: '#f9fafb',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          color: colors.text.secondary,
          '&.Mui-focused': {
            color: colors.primary.main,
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          marginBottom: 4,
          transition: 'all 0.2s ease',
          // Add horizontal margin for better padding from drawer edges
          marginLeft: 12,
          marginRight: 12,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
          },
          '&.Mui-selected': {
            backgroundColor: colors.common.white,
            // boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
            '&:hover': {
              backgroundColor: colors.common.white,
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: colors.text.secondary,
          '.Mui-selected &': {
            color: colors.primary.light,
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          // Add padding to the list container
          padding: '8px 0',
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          height: 24,
          fontSize: '0.75rem',
          fontWeight: 500,
        },
        colorPrimary: {
          backgroundColor: '#eef2ff',
          color: colors.primary.main,
        },
        colorSuccess: {
          backgroundColor: colors.success.light,
          color: colors.success.dark,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontSize: '0.875rem',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          marginTop: 4,
          boxShadow: '0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.03)',
          border: '1px solid #e2e8f0',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          padding: '8px 16px',
          '&:hover': {
            backgroundColor: '#f3f4f6',
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: colors.divider,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 8,
          borderRadius: 4,
          backgroundColor: colors.divider,
        },
        bar: {
          borderRadius: 4,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600,
          color: colors.secondary.dark,
          fontSize: '0.875rem',
          borderBottom: `1px solid ${colors.divider}`,
        },
        body: {
          fontSize: '0.875rem',
          borderBottom: '1px solid #f3f4f6',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f9fafb',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.125rem',
          fontWeight: 600,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: 20,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
          gap: 8,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: colors.action.hover,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${colors.divider}`,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
          color: colors.text.secondary,
          '&.Mui-selected': {
            color: colors.primary.main,
          },
        },
      },
    },

    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: colors.secondary.main,
          transition: 'color 0.2s ease, transform 0.2s ease',
          '&.Mui-active': { color: colors.primary.main, transform: 'scale(1.1)' },
          '&.Mui-completed': { color: colors.success.main },
          '&:hover': {
            color: colors.primary.light,
            transform: 'scale(1.15)',
            cursor: 'pointer',
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          '.string-of-pearls &': {
            [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 22 },
            [`&.${stepConnectorClasses.active}, &.${stepConnectorClasses.completed}`]: {
              [`& .${stepConnectorClasses.line}`]: {
                backgroundImage: `linear-gradient(95deg, ${colors.primary.light} 0%, ${colors.primary.main} 50%, ${colors.primary.dark} 100%)`,
              },
            },
            [`& .${stepConnectorClasses.line}`]: {
              height: 3,
              border: 0,
              backgroundColor: colors.divider,
              borderRadius: 1,
            },
          },
        },
      },
    },
  },
});
